import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AssetObj, SectorObj, VendorObj } from '../interfaces/AssetProps';
import { ApiHandler } from '../services/apiHandler';
import AccordionInput from './AccordionInput';
import ErrorAlert from './ErrorAlert';
import Spinner from './Spinner';

interface CbsdAccordionProps {
  assetDetails: AssetObj | undefined;
  sectorDetails: SectorObj | undefined;
  vendorDetails: VendorObj | undefined;
  updateDetails: any;
}
const CbsdAccordion: React.FC<CbsdAccordionProps> = ({ assetDetails, sectorDetails, vendorDetails, updateDetails }) => {
  let navigate = useNavigate();
  const [vendors, setVendors] = useState<{ id: string; vendor_name: string; vendor_model: string; bands: any[] }[] | undefined>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    message: '',
    alert: false,
  });

  // const mountingTypes = [
  //   {
  //     id: 'Aerial',
  //     vendor_name: 'Strand',
  //     vendor_model: '',
  //   },
  //   {
  //     id: 'ROE',
  //     vendor_name: 'Macro',
  //     vendor_model: '',
  //   },
  //   {
  //     id: 'SMB',
  //     vendor_name: 'SMB',
  //     vendor_model: '',
  //   },
  // ];

  // const BAND_NAME_MAP: Record<string, string> = {
  //   '2_4g': '2.4GHz',
  //   '3_5g': '3.5GHz',
  //   '5_g': '5GHz',
  //   '6_g': '6GHz',
  // };

  // const BAND_TYPE_MAP: Record<string, string> = {
  //   '2_4g': 'Unlicensed',
  //   '3_5g': 'CBRS',
  //   '5_g': 'Unlicensed',
  //   '6_g': 'AFC',
  // };

  useEffect(() => {
    listVendors(assetDetails?.mounting_type?.toLowerCase() || '');
  }, [assetDetails]);

  const listVendors = (mountingType: string) => {
    ApiHandler({ apiName: 'listVendors', body: {}, params: {}, queryParams: {} })
      .then((response: any) => {
        let technology: string = assetDetails?.technology_type || '';
        if (technology === 'wifi_6e') {
          setVendors(response.data['wifi']);
        } else if (technology === 'cpe_cbsd') {
          setVendors(response.data['cpe_cbsd']);
        } else if (technology === 'cpe_wifi') {
          setVendors(response.data['cpe_wifi']);
        } else if (technology === 'tarana_cpe') {
          setVendors(response.data['tarana_cpe']);
        } else if (technology === 'tarana') {
          setVendors(response.data['tarana']);
        } else setVendors(response.data[mountingType || '']);
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };

  return (
    <div className="py-3 px-1">
      <AccordionInput
        type="vendor-dropdown"
        title="Vendor Name"
        disabled={sectorDetails?.submitted_to_sas || false}
        value={assetDetails?.vendor_id?.toString()}
        options={vendors}
        onChange={(e: any) => {
          updateDetails('vendor_id', parseInt(e.target.value), 'asset');
        }}
      />
      <AccordionInput type="input" title="Software Version" disabled value={vendorDetails?.software_version || ''} />
      <AccordionInput type="input" title="Hardware Version" disabled value={vendorDetails?.hardware_version || ''} />
      <AccordionInput type="input" title="Firmware Version" disabled value={vendorDetails?.firmware_version || ''} />
      <Spinner show={loading} />
      <ErrorAlert
        show={error.alert}
        onDismiss={() => {
          setError({ message: '', alert: false });
        }}
        message={error.message}
      />
    </div>
  );
};

export default CbsdAccordion;
